import { FunctionComponent } from "react"
import { useNavigate } from "react-router-dom"
import { ArrowLeftIcon } from "@heroicons/react/24/outline"
import { SIDEBAR_WIDTH_CLOSED } from "./sidebar-contents"

/**
 * Minimal sidebar for simulation pages.
 * Shows only the Meseekna logo and an exit button.
 * Used to maintain brand consistency while eliminating menu overflow issues.
 */
const SidebarMinimal: FunctionComponent = () => {
  const navigate = useNavigate()

  const handleLogoClick = () => {
    navigate("/dashboard")
  }

  const handleExitClick = () => {
    navigate("/dashboard")
  }

  return (
    <div
      className="h-full border-gray-200 border-r-[1px] border-solid box-border flex flex-col items-center pt-8 gap-6"
      style={{ width: SIDEBAR_WIDTH_CLOSED }}>
      {/* Logo - clickable */}
      <div
        className="cursor-pointer flex items-center justify-center"
        onClick={handleLogoClick}
        title="Go to Dashboard">
        <img
          className="h-[42.8px] w-[42.8px] object-contain"
          alt="meseekna-logo"
          src="/v3/assets/image-14@2x.png"
        />
      </div>

      {/* Exit button */}
      <button
        onClick={handleExitClick}
        className="flex flex-col items-center gap-1 p-2 rounded-md hover:bg-gray-100 cursor-pointer border-none bg-transparent"
        title="Exit to Dashboard">
        <ArrowLeftIcon className="w-6 h-6 text-gray-500" />
        <span className="text-xs text-gray-600 font-medium">Exit</span>
      </button>
    </div>
  )
}

export default SidebarMinimal
